import type { LinkPreviewDto } from '../api/client';

/**
 * Какие картинки превью ссылки грузить и откуда (аудит 2026-10-17, PRIV-4).
 *
 * <p>og:image и значок сайта раньше грузились с чужого сервера прямо с телефона получателя:
 * владелец сайта видел его IP и момент, когда тот открыл чат, хотя по ссылке никто не нажимал.
 * Теперь картинки идут только через наш сервер — по пути `/api/link-preview/image/<токен>`, — а
 * исходные `imageUrl`/`faviconUrl` из ответа не используются вовсе.
 *
 * <p>Правило вынесено из компонента, чтобы его проверял тест: «показать картинку» и «выдать IP
 * чужому сайту» в разметке различаются одним полем, и перепутать их легко.
 */

const LINK_PREVIEW_IMAGE_PATH_RE = /^\/api\/link-preview\/image\/[0-9a-f]{32}$/;

/** Наш ли это путь прокси. Всё прочее — чужой адрес, и грузить его нельзя. */
export function isLinkPreviewImagePath(value: string | null | undefined): value is string {
  return typeof value === 'string' && LINK_PREVIEW_IMAGE_PATH_RE.test(value);
}

function proxyPathOrNull(value: string | null | undefined): string | null {
  return isLinkPreviewImagePath(value) ? value : null;
}

/** Картинка и значок карточки сайта — только пути прокси, иначе `null`. */
export function websitePreviewImagePaths(preview: LinkPreviewDto | null | undefined): {
  image: string | null;
  favicon: string | null;
} {
  return {
    image: proxyPathOrNull(preview?.imageProxyPath),
    favicon: proxyPathOrNull(preview?.faviconProxyPath),
  };
}

/** Обложка ролика YouTube из превью — тоже только через прокси. */
export function youtubePreviewThumbPath(preview: LinkPreviewDto | null | undefined): string | null {
  return proxyPathOrNull(preview?.imageProxyPath);
}
